"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeSlotType = exports.timeSlotDayType = exports.reservationType = exports.notarySessionType = exports.notaryRequirementType = exports.notaryParticipantType = exports.notaryDocumentType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var notaryParticipantType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  name: _propTypes.default.string,
  accepted: _propTypes.default.bool // self-created

});

exports.notaryParticipantType = notaryParticipantType;

var notaryRequirementType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  description: _propTypes.default.string,
  checked: _propTypes.default.bool
});

exports.notaryRequirementType = notaryRequirementType;

var notaryDocumentType = _propTypes.default.shape({
  notarySessionDocumentUuid: _propTypes.default.string,
  documentUuid: _propTypes.default.string,
  filename: _propTypes.default.string,
  type: _propTypes.default.string,
  participants: _propTypes.default.arrayOf(notaryParticipantType),
  requirements: _propTypes.default.arrayOf(notaryRequirementType),
  accepted: _propTypes.default.bool // self-created

});

exports.notaryDocumentType = notaryDocumentType;

var notarySessionType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  accessToken: _propTypes.default.string,
  documents: _propTypes.default.arrayOf(notaryDocumentType),
  accepted: _propTypes.default.bool
});

exports.notarySessionType = notarySessionType;

var timeSlotType = _propTypes.default.shape({
  startTime: _propTypes.default.string,
  timeSlotMinutes: _propTypes.default.number,
  available: _propTypes.default.number
});

exports.timeSlotType = timeSlotType;

var timeSlotDayType = _propTypes.default.shape({
  dayOfWeek: _propTypes.default.string,
  date: _propTypes.default.string,
  timeSlots: _propTypes.default.arrayOf(timeSlotType)
});

exports.timeSlotDayType = timeSlotDayType;

var reservationType = _propTypes.default.shape({
  identityUuid: _propTypes.default.string,
  appUuid: _propTypes.default.string,
  notarySessionRoomUuid: _propTypes.default.string,
  time: _propTypes.default.string,
  phoneNumber: _propTypes.default.string
});

exports.reservationType = reservationType;